import React from 'react';
import { useFooterQuery } from '@querys/useFooterQuery';
import { Link } from 'gatsby';
import { SanityImage } from '@components/sanity/sanityImage';

import NeutralButton from '@components/UI/neutralButton';

export const Footer = () => {
  const { footerLogo, footerText, socialLinks, supporters, externalLinks } =
    useFooterQuery();

  return (
    <div className='relative text-white  bg-gradient-to-r from-[#122E53] to-[#04152E] '>
      <div
        className='absolute top-0 left-0  h-20'
        style={{
          width: ' 100%',
          background: `linear-gradient(to left top, transparent 50%, #F0F6F3 50.90%)`,
          transform: 'translateY(-1px)',
        }}
      />
      <div className='  md:grid grid-cols-8 px-[22px] lg:px-12 pt-40 md:pt-48 '>
        <SanityImage
          image={footerLogo}
          className='w-[250px] md:w-[450px] col-start-6 col-end-9 row-start-1 justify-self-end mx-auto md:mx-0'
        />
        <p className='blockH4 col-start-1 col-end-5 row-start-1 pt-14 md:pt-0 text-center md:text-left pb-8 lg:pb-6 self-end'>
          {footerText}
        </p>

        <NeutralButton
          linkPath='/contact'
          linkText='Contact CoolLogic'
          extraClasses='mx-auto md:mx-0 mb-16 col-start-1 col-end-5  '
        />
        <div className='col-start-1 col-end-5 pb-9 opacity-50 text-center md:text-left'>
          <Link to='/legal'>Legal and T&Cs</Link>
          <p>© 2022 CoolLogic All Rights Reserved</p>
        </div>

        <div className='flex col-start-6 col-end-9 justify-self-end space-x-4 justify-center md:justify-end pb-14 md:pb-0 '>
          {supporters.map((supporter, i) => (
            <Link to={supporter?.link} target='_blank'>
              <SanityImage
                image={supporter?.linkImage}
                className='h-10 '
                key={i}
              />
            </Link>
          ))}
        </div>
      </div>
      <div className='md:flex justify-between   px-6 xx:px-12 text-center md:text-left backdrop-blur-xs bg-white/5  '>
        <div className='flex flex-col md:flex-row   py-6 blockH9 gap-x-4 xx:gap-x-6 space-y-5 md:space-y-0  '>
          <p className='font-medium py-4 md:py-0'>
            A Member of Horizon Energy Group
          </p>
          {externalLinks.map((link, i) => (
            <a
              href={link?.link}
              target='_blank'
              rel='noreferrer'
              className='hover:opacity-50 transition-all duration-500 ease-in-out'
              key={i}>
              {link?.linkText}
            </a>
          ))}
        </div>
        <div className='flex  justify-self-end self-center space-x-4 justify-center md:justify-end pt-5 md:pt-0 pb-10 md:pb-0 '>
          {socialLinks.map((link, i) => (
            <a href={link?.link} target='_blank' rel='noreferrer' key={i}>
              <SanityImage image={link?.linkImage} className='h-[24px] ' />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
